import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {getChecklisteDetail, getChecklisteListeUiSelektiert, PageState} from './checklisten.reducer';
import {NotificationService} from '@orga-app/providers/notification.service';
import {Observable} from 'rxjs';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../websocket.actions';
import {filter, map, withLatestFrom} from 'rxjs/operators';
import {PandemieEntityTypes, VorlagenEntityTypes} from '../../../client-constants';
import {GetChecklisteDetailAction, GetChecklisteAufgabenAction, GetFunktionsbereicheChecklistenAction} from '../../../client-ngrx/vorlagen';
import {FunktionsbereichDetail} from '../../../clients/benutzerverwaltung';
import {Checkliste} from '../../../clients/vorlagen';
import {getIstPandemieLizenzAktiv} from '@orga-app/mandant/reducer';
import {GetChecklistePandemieLevelInfoAction} from '../../../client-ngrx/pandemie';
import CHECKLISTE_ENTITY = VorlagenEntityTypes.CHECKLISTE_ENTITY;

@Injectable()
export class EffectsWs {

    @Effect()
    readModelUpdaterFunktionsbereicheChecklisten$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY;
        })
        , map((x) => {
            return new GetFunktionsbereicheChecklistenAction(false);
        })
    );

    @Effect()
    readModelChecklistenDetail$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY;
        })
        , withLatestFrom(this.store.pipe(select(getChecklisteDetail)))
        , filter(([x, checkliste]: [WsReadModelUpdatedAction, Checkliste]) => {
            return checkliste !== null && checkliste.checkliste_id !== undefined;
        })
        , map(([x, checkliste]: [WsReadModelUpdatedAction, FunktionsbereichDetail]) => {
            return [<Checkliste> JSON.parse(x.message.entity), checkliste];
        })
        , filter(([x, checkliste]: [Checkliste, Checkliste]) => {
            return x.checkliste_id !== undefined && checkliste.checkliste_id !== undefined && x.checkliste_id === checkliste.checkliste_id;
        })
        , map(([x, checkliste]) => {
            return new GetChecklisteDetailAction(checkliste.checkliste_id);
        })
    );

    @Effect()
    readModelUpdaterAufgabe$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VorlagenEntityTypes.AUFGABE_ENTITY && x.message.reason !== 'OrgaApp.Vorlagen.Messages.Events.AufgabeReihenfolgeGesetztEvent';
        })
        , withLatestFrom(this.store.pipe(select(getChecklisteListeUiSelektiert)))
        , filter(([x, checkliste]) => {
            return (checkliste != null && checkliste.checkliste_id != null);
        })
        , map(([x, checkliste]) => {
            return new GetChecklisteAufgabenAction(checkliste.checkliste_id);
        })
    );

    @Effect()
    readModelUpdaterAufgabePandemieLevelInfos$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === PandemieEntityTypes.AUFGABE_ENTITY;
        })
        , withLatestFrom(this.store.pipe(select(getChecklisteListeUiSelektiert)),
            this.store.pipe(select(getIstPandemieLizenzAktiv)))
        , filter(([x, checkliste, istPandemieLizenzAktiv]) => {
            return (istPandemieLizenzAktiv && checkliste != null && checkliste.checkliste_id != null);
        })
        , map(([x, checkliste, istPandemieLizenzAktiv]) => {
            return new GetChecklistePandemieLevelInfoAction(checkliste.checkliste_id);
        })
    );


    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private notificationService: NotificationService) {
    }
}
